export default "__VITE_ASSET__ZosXnjKQ__"